import { apolloClient } from './apollo.js';
import jwtDecode from '@nitra/jwt-decode';
import { getToken } from '@nitra/components/njs/token.js';
export let roles = null;
export let adminGroups = null;
export let adminRoles = null;
export const user = jwtDecode(getToken());
const consola = createLogger(__filename);

// ініціалізуємо Vuex та roles для Casl
export default async () => {
  var _response$data$user, _response$data$user$u;
  if (!apolloClient) {
    consola.debug('Skip UserData boot');
    return;
  }
  consola.debug('Start UserData boot');

  // Дані по користувачу
  const response = await apolloClient.query({
    query: gql`
      query user($email: String!) {
        user: user_by_pk(email: $email) {
          name
          user_role {
            permissions
          }
        }
      }
    `,
    variables: {
      email: user['https://hasura.io/jwt/claims']['x-hasura-user-id']
    }
  });
  roles = ((_response$data$user = response.data.user) === null || _response$data$user === void 0 ? void 0 : (_response$data$user$u = _response$data$user.user_role) === null || _response$data$user$u === void 0 ? void 0 : _response$data$user$u.permissions) || null;
  adminGroups = null; // response.data?.user?.admin_permissions?.groups || null
  adminRoles = null; // response.data?.user?.admin_permissions?.roles || null

  consola.debug('End userData boot');
};